import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Route } from 'react-router-dom'
import { PropTypes } from 'prop-types'
import Loader from '../components/common/loader'
import AuthActions from '../store/authRedux'
import LayoutActions from '../store/layoutRedux'
import auth from '../services/auth/AuthProvider'
import InactivityMonitor from '../components/inactivity_monitor/InactivityMonitor'
import TimerController from '../app/TimerController'

const PrivateRoute = props => {

    const { isPageLoading, setPageLoading, finalizeLogout, requestLogin, restoreUserSession, children } = props

    useEffect(() => {
        if (!auth.isAuthenticated()) {
            // force logout session clearing and do a login request
            setPageLoading(true);
            finalizeLogout();
            requestLogin();
        } else {
            // we're authenticated, but we need to restore some basic session data
            setPageLoading(true);
            restoreUserSession();
        }
    }, [])

    return (
        <Route {...props}>
            {isPageLoading || !auth.isAuthenticated() ? <Loader /> : children}
            <InactivityMonitor />
            <TimerController />
        </Route>)
}

PrivateRoute.propTypes = {
    isPageLoading: PropTypes.bool,
    token: PropTypes.string,
    requestLogin: PropTypes.func.isRequired,
    restoreUserSession: PropTypes.func.isRequired,
    finalizeLogout: PropTypes.func.isRequired,
}

const mapStateToProps = (state, ownProps) => {
    return {
        ownProps,
        isPageLoading: state.layout.isPageLoading
    }
}

const mapDispatchToProps = (dispatch) => ({
    requestLogin: () => dispatch(AuthActions.requestLogin()),
    restoreUserSession: () => dispatch(AuthActions.restoreUserSession()),
    finalizeLogout: () => dispatch(AuthActions.finalizeLogout()),
    setPageLoading: (isLoading) => dispatch(LayoutActions.setPageLoading(isLoading))
})

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute);